// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-search-dnd-preference',
//   templateUrl: './search-dnd-preference.component.html',
//   styleUrls: ['./search-dnd-preference.component.css']
// })
// export class SearchDndPreferenceComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }



import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Lifecycle } from 'src/app/_helpers/Lifecycle/Lifecycle.class';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';

import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common'; import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';
import { APIDndRegistrationDetails } from '../../_services/dnd-registration-details/API-dnd-registration-details';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-search-dnd-preference',
  templateUrl: './search-dnd-preference.component.html',
  styleUrls: ['./search-dnd-preference.component.css']
})





export class SearchDndPreferenceComponent implements OnInit {

  public subscriberdetails: any;
  dndPreference: FormGroup;
  cmode: any;
  time: any;
  ctgr: any;
  day: any;
  reqno: any;
  cts: any;
  mobilenumber: any;
  displayedColumns2: string[] = ['cmode', 'time', 'ctgr', 'day', 'reqno', 'cts'];
  dataSource: MatTableDataSource<any>;
  noRecord: any;
  displayTable: boolean = false;


  modeOfCommunicationData = new Map([[11, 'Voice Call'],
  [13, 'Auto Dailer Call with Pre-recorded'], [14, 'Auto Dailer Call with Live Agent'], [15, 'Robo-calls']]);

  // For Time Bands
  tbCheck: boolean = false;
  timeBandsData = new Map([[21, '00:00 Hrs to 06:00 Hrs'], [22, '06:00 Hrs to 08:00 Hrs'], [23, '08:00 Hrs to 10:00 Hrs'],
  [24, '10:00 Hrs to 12:00 Hrs'], [25, '12:00 Hrs to 14:00 Hrs'], [26, '14:00 Hrs to 16:00 Hrs'],
  [27, '16:00 Hrs to 18:00 Hrs'], [28, '18:00 Hrs to 21:00 Hrs'], [29, '21: 00 Hrs to 24:00 Hrs']]);

  //For Day Type
  mcckeys: any[];
  timekeys: any[];
  dayskeys: any[];
  ctgrkeys: any[];
  mccString = [];
  timeString = [];
  daysString = [];
  ctgrString = [];


  daysData = new Map([[31, 'Mon'], [32, 'Tue'], [33, 'Wed'], [34, 'Thu'], [35, 'Fri'],
  [36, 'Sat'], [37, 'Sun'], [38, 'Public Holiday & National Holiday']]);

  //For category
  categoryData = new Map([[1, 'Banking / Insurance / Financial products / credit cards'],
  [2, 'Real Estate'], [3, 'Education'],
  [4, 'Health'], [5, 'Consumer Goods and Automobiles'], [6, 'Communication / Broadcasting / Entertainment / IT'],
  [7, 'Tourism and Leisure'], [8, 'Food and Beverages']]);


  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;
  constructor(private fb: FormBuilder,

    private $modal: $ModalManagerService,

    private db: $DBManagerService,
    private _call: APIDndRegistrationDetails, ) { }
  ngOnInit() {
    this.dndPreference = this.fb.group({
      number: ['', Validators.required],
      cmode: ['', Validators.required],
      time: ['', Validators.required],
      ctgr: ['', Validators.required],

      reqno: ['', Validators.required],
      day: ['', Validators.required],
      msisdn: ['', Validators.required],
    })
  }
  get f() { return this.dndPreference.controls; }

  onSubmit() {
    this.mccString = [];
  this.timeString = [];
  this.daysString = [];
  this.ctgrString = [];

    this.mobilenumber = this.dndPreference.get('number').value;
    console.log("This mobilenumber ", this.mobilenumber)

    if (this.mobilenumber) {

      this._call.getSubscriberPreferenceDetails(this.mobilenumber)
        .subscribe(r => {

          this.subscriberdetails = r;
          console.log("this.subscriberdetails ___________", this.subscriberdetails);
          console.log("this.subscriberdetails ________,", this.subscriberdetails.preferences);
          console.log("r.data,", r.data);

          if (this.subscriberdetails.preferences) {
            this.onChangeDataSource(this.subscriberdetails.preferences)
            this.displayTable = true;
          }
          else {
            this.$modal.errorModal({
              title: 'DND Preference',
              msg: 'Data Not Found'
            });
            this.displayTable = false;
          }
        });
    }
  }
  onChangeDataSource(value) {
    console.log("value",value)
    this.dataSource = new MatTableDataSource(value);
    // this.dataSource.paginator =this.paginator.toArray()[0];
    this.dataSource.sort = this.t1Sort;
    this.dataSource.data = value;
    this.cmode = this.dataSource.data['cmode'];
    this.time = this.dataSource.data['time'];
    this.ctgr = this.dataSource.data['ctgr'];
    this.day = this.dataSource.data['day'];
    this.reqno = this.dataSource.data['reqno'];
	this.cts = this.dataSource.data['cts'];

    this.mcckeys = this.cmode.split(',');
    this.mcckeys = this.mcckeys.filter(function (entry) { return entry.trim() != ''; });

    this.timekeys = this.time.split(',');
    this.timekeys = this.timekeys.filter(function (entry) { return entry.trim() != ''; });

    this.ctgrkeys = this.ctgr.split(',');
    this.ctgrkeys = this.ctgrkeys.filter(function (entry) { return entry.trim() != ''; });


    this.dayskeys = this.day.split(',');
    this.dayskeys = this.dayskeys.filter(function (entry) { return entry.trim() != ''; });


    if (this.mcckeys.length == 0) {
      this.mccString[0] = "No mode is selected"
    }
    else {
      for (let i = 0; i < this.mcckeys.length; i++) {
        this.mccString[i] = this.modeOfCommunicationData.get(this.mcckeys[i] * 1)
      }
    }
    console.log("hhhhhhhhhhhhh", this.mcckeys.length);
    console.log("iiiiiiiiiii", this.mcckeys[0]);
    console.log("jjjjjjjj", typeof this.mcckeys[0]);
    console.log("this.timekeys.length", this.timekeys.length);
    console.log("this.dayskeys.length", this.dayskeys.length);
    console.log("this.ctgrkeys.length", this.ctgrkeys.length);


    if (this.timekeys.length == 0) {
      this.timeString[0] = "No time is selected"
    }
    else
      for (let i = 0; i < this.timekeys.length; i++) {
        {
          this.timeString[i] = this.timeBandsData.get(this.timekeys[i] * 1)
        }
      }
    if (this.dayskeys.length == 0) {
      this.daysString[0] = "No Day is selected"
    }
    else {

      for (let i = 0; i < this.dayskeys.length; i++) {

        this.daysString[i] = this.daysData.get(this.dayskeys[i] * 1)
      }
    }

    if (this.ctgrkeys.length == 0 ) {
      this.ctgrString[0] = "No Category is selected"
    }
    else {


      for (let i = 0; i < this.ctgrkeys.length; i++) {


        this.ctgrString[i] = this.categoryData.get(this.ctgrkeys[i] * 1)
      }
    }
    console.log(this.modeOfCommunicationData.get(11))
    console.log(this.modeOfCommunicationData.get(this.mcckeys[0] * 1))

    console.log("this.mccString", this.mccString)
    console.log(this.timekeys)
    console.log(this.ctgrkeys)
    console.log(this.dayskeys)



    console.log("this.dataSource", this.dataSource)
    console.log(this.dataSource.data);

    console.log("this.cmode", this.cmode)
    // this.dndPreference.controls['cmode'].setValue(this.mccString);
    // this.dndPreference.controls['time'].setValue(this.timeString);
    // this.dndPreference.controls['ctgr'].setValue(this.ctgrString);

    // this.dndPreference.controls['day'].setValue(this.daysString);
    this.dndPreference.controls['reqno'].setValue(this.reqno);





    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

}

